import React from 'react';
import cls from "classnames"
import * as styles from './CodeSnippet.module.scss';
import './CodeSnippet.scss';
import {IdHeading} from "components/organisms/IdHeading";

type Props = {
  code: string
  title?: string
  classNames?: {
    container: string
  }
}

export const CodeSnippet = ({ code, title, classNames }: Props) => (
  <section className={cls(styles.container, classNames?.container)}>
    <div className={"bs-flex-container"}>
      {title && <IdHeading headingLevel={3} className={styles.title}>{title}</IdHeading>}
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: code }} />
    </div>
  </section>
)
